/**
 * FilterAndDisplay Functional Component
 * @Package - seo/brand
 * @Author - Cybage@UPWA-Team
 * @description: FilterAndDisplay related to brand SEO
 */
/**
 *  Brand SEO's FilterAndDisplay Component
 */
import React from 'react'
import SeoFilterAndDisplay from '../SeoFilterAndDisplay'
import config from '../../../../config/local-config'

export default function FilterAndDisplay({
  dynamicApiData,
  isComponentChanged,
  apiDetails: {
    sortOptions = config.sortOptions,
    props: { core },
  },
}) {
  const id = dynamicApiData.headings.summary === ''
    ? 'BrandstoreFilterAndDisplay'
    : 'BrandFilterAndDisplay'

  return (
    <SeoFilterAndDisplay
      id={id}
      dynamicApiData={dynamicApiData}
      isComponentChanged={isComponentChanged}
      sortOptions={sortOptions}
      coreConfig={core}
    />
  )
}
